import { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useOnClickOutside } from 'src/hooks/useOnClickOutside'

import { routes } from 'src/navigation/routes'

const StudentRow = ({ item, onInviteClick }) => {
  const refMenu = useRef()
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  useOnClickOutside(refMenu, () => setIsMenuOpen(false))

  const handleMenuOpen = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <div className="details-table__row">
      <div className="details-table__col details-table__col-1">
        <div className="checkbox">
          <input type="checkbox" />
          <i className="checkbox-ico" />
        </div>
      </div>
      <div className="details-table__col details-table__col-2">
        <div className="details-table__main">
          <div className="details-table__user">
            <Link
              to={routes.students.show(item.id)}
              className="details-table__ava"
            >
              {item.avatar ? (
                <img
                  src={item.avatar || '/account/img/human-1-min.jpg'}
                  alt=""
                />
              ) : (
                <span />
              )}
            </Link>
            <Link
              to={routes.students.show(item.id)}
              className="details-table__name"
            >
              {item.first_name} {item.last_name}{' '}
            </Link>
          </div>
          <span className="details-table__text">{item?.username}</span>
        </div>
      </div>
      <div className="details-table__col details-table__col-3">
        {item?.practices_score}/{item?.practices_count}
      </div>
      <div className="details-table__col details-table__col-4">
        {item?.tests_score}/{item?.tests_count}
      </div>
      <div className="details-table__col details-table__col-5">
        {item?.tests_done}%
      </div>
      <div className="details-table__col details-table__col-6">
        <span className="green-color">+{item?.progress}</span>
      </div>
      <div className="details-table__col details-table__col-7">
        <i className="hb-ico help-ico" />
      </div>
      <div className="dropHb">
        <div className="dropHb-top">
          <i className="hb-ico dots-ico" />
        </div>
        <div className="dropHb-info">
          <ul>
            <li>
              <a href="#">
                <i className="hb-ico clear-ico" />
                Dismiss
              </a>
            </li>
            <li>
              <a data-fancybox="" data-src="#assign" href="javascript:;">
                <i className="hb-ico checkCircle-ico" />
                Assign to class
              </a>
            </li>
            <li>
              <a href="#">
                <i className="hb-ico report-ico" />
                Report card
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default StudentRow
